// src/auth/index.js
/* eslint-disable */
import { router } from '../main'
import axios from 'axios'

// URL and endpoint constants
const LOGIN_URL = `${process.env.API_URL}login/`
let result = ''

export default {

  // User object will let us check authentication status
  user: {
    authenticated: false,
    clientID: ''
  },

  // Send a request to the login URL and save the returned JWT
  login(context, creds, redirect) {
    result = this
    var credentials = btoa(creds.username + ':' + creds.password)
    axios.post(LOGIN_URL,
      {},
      // the data to post
      {
        headers: { 'Authorization': 'Basic ' + credentials }
      })
      .then(response => {
        result = response.data
        if (result.authenticated === false) {
          // error = 'Something went wrong, user is not authenticated'
          this.user.authenticated = false
          if (result.lockoutTime_Mins) {
            context.error = 'This account has been locked for 10 minutes, please try logging in again later'
          } else {
            context.error = 'Something went wrong, username and or password incorrect, please try again.'
          }
          router.push('/login')
        } else {
          localStorage.setItem('clientID', result.entityID)
          localStorage.setItem('access_token', result.token)
          localStorage.setItem('userEmail', result.userEmail)
          this.user.authenticated = true
          this.user.clientID = result.entityID
          router.push('/contracts')
        }
      })
      .catch((error) => {
        if (result.lockoutTime_Mins) {
          this.context.error = 'This account has been locked for 10 minutes, please try logging in again later'
        } else {
          this.context.error = 'Something went wrong, username and or password incorrect, please try again.'
        }
        router.push('/login')
      })
  },

  // To log out, we just need to remove the token
  logout() {
    localStorage.removeItem('clientID')
    localStorage.removeItem('access_token')
    localStorage.removeItem('userEmail')
    this.user.authenticated = false
    this.user.clientID = ''
    router.push('/login')
  },
  checkAuth() {
    var jwt = localStorage.getItem('clientID')
    if (jwt) { this.user.authenticated = true } else { this.user.authenticated = false }
  },

  // The object to be passed as a header for authenticated requests
  getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
      'Cache-Control': 'no-cache'
    }
  },
  // The object to be passed as a header for authenticated requests
  getAuthHeader1(incoming) {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
      'Cache-Control': 'no-cache',
      'encodedDetails': incoming
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js